/**
 * Checks if string is null or whitespace or tabs
 * @param  {string} str The string to check
 * @return {boolean}    The Result
*/
const isStringNullOrWhiteSpace = (str) => {
    return str === null || (/^\s*$/).test(str);
};
